// ownerNav.ts — مصدر واحد لعناصر تنقّل بوابة المالك (خطة Owner_Portal_UX_Redesign_Plan_2026-07-12.md
// §3.3). كانت هذه القائمة مكرَّرة بين OwnerSidebar.tsx وOwnerBottomNav.tsx في v3.12.0 —
// دُمجت هنا (تنظيف مطلوب في الخطة، لا اختياريّ) وتُستهلَك الآن من OwnerTopBar وOwnerBottomNav
// وPortalSwitcher معًا.
import { IconChartBar, IconDroplet, IconHome2, IconHorse, IconTrophy, IconWallet } from '@tabler/icons-react';

export interface OwnerNavItem {
	path: string;
	textKey: string;
	fallback: string;
	Icon: typeof IconHome2;
}

// وجهات الشريط العلويّ/السفليّ (6) — «إحصائياتي» كانت في قائمة الأفاتار (§3.1/§12.2)، ونُقلت
// للشريط المرئيّ بجانب «خيولي» بطلب المستخدم (2026-07-12).
export const OWNER_NAV_ITEMS: OwnerNavItem[] = [
	{ path: '/owner-home', textKey: 'client_owner_home', fallback: 'خيلي اليوم', Icon: IconHome2 },
	{ path: '/my-horses', textKey: 'client_horses', fallback: 'خيولي', Icon: IconHorse },
	{ path: '/my-horse-stats', textKey: 'client_horse_stats', fallback: 'إحصائياتي', Icon: IconChartBar },
	{ path: '/my-finance', textKey: 'client_finance', fallback: 'حسابي المالي', Icon: IconWallet },
	{ path: '/my-pregnancy', textKey: 'client_pregnancy', fallback: 'متابعة الحمل', Icon: IconDroplet },
	{ path: '/my-milestones', textKey: 'client_milestones', fallback: 'معالم وإنجازات', Icon: IconTrophy },
];

// كل مسارات بوابة المالك الستّة — تُستخدَم لاكتشاف «هل أنا على جانب المالك؟» في PortalSwitcher
// وحصر مساحة المفاتيح في hasAdminPage.
export const ALL_OWNER_PATHS: string[] = OWNER_NAV_ITEMS.map((item) => item.path);

/** true إن كان المسار الحاليّ داخل بوابة المالك (يشمل مسارات فرعيّة مثل /my-horses/:horseId). */
export function isOwnerPath(pathname: string): boolean {
	const p = pathname.toLowerCase();
	return ALL_OWNER_PATHS.some((path) => p === path.toLowerCase() || p.startsWith(`${path.toLowerCase()}/`));
}
